const ShowsList = [
  {
      start: new Date(2019,1,8,19,0),
      end: new Date(2019,1,8,22,0),
      title: "4th Annual Mocktail Party",
      information: "Background music during dinner and dancing after! Featuring mocktail bar.",
      fb: "https://www.facebook.com/events/2113585148689131/",
      insta: null
  },
  {
      start: new Date(2019,1,18,19,0),
      end: new Date(2019,1,18,21,0),
      title: "Valentines Dinner Dance",
      information: "Background music during dinner and dancing after!",
      fb: null,
      insta: null
  },
  {
      start: new Date(2019,1,23,18,30),
      end: new Date(2019,1,23,21,0),
      title: "AhiMuse Jazz Night",
      information: "Steak and Sushi at AhiMuse in Orem. Must purchase food to enter.",
      fb: "https://www.facebook.com/events/243399983270327/",
      insta: null
  },
  {
      start: new Date(2019,2,22,18,30),
      end: new Date(2019,2,22,21,0),
      title: "AhiMuse Jazz Night",
      information: "New covers and originals!",
      fb: "https://www.facebook.com/events/298363184171445/",
      insta: null
  },
  {
      start: new Date(2019,3,13,21,0),
      end: new Date(2019,3,13,22,0),
      title: "Merit Academy Prom",
      information: "Great Gatsby themed, jazz tunes and pop tunes.",
      fb: null,
      insta: null
  },
  {
      start: new Date(2019,3,19,18,30),
      end: new Date(2019,3,19,21,0),
      title: "AhiMuse Jazz Night",
      information: "New covers and originals!",
      fb: "https://www.facebook.com/events/807374562952899/",
      insta: null
  },
  {
      start: new Date(2019,4,4,18,0),
      end: new Date(2019,4,4,20,0),
      title: "Vaughn Wedding",
      information: "",
      fb: null,
      insta: null
  },
  {
      start: new Date(2019,4,10,18,0),
      end: new Date(2019,4,10,20,0),
      title: "Breeze Wedding",
      information: "",
      fb: null,
      insta: null
  },
  {
      start: new Date(2019,4,17,18,0),
      end: new Date(2019,4,17,20,0),
      title: "AhiMuse Jazz Night",
      information: "Steak and sushi at AhiMuse!",
      fb: "https://www.facebook.com/events/361585721137562/",
      insta: null
  },
  {
    start: new Date(2019,5,8,18,0),
    end: new Date(2019,5,8,21,0),
		title: "AhiMuse Jazz Night",
		information: "Come enjoy steak and sushi at AhiMuse. We're debuting several new originals!",
    fb: "https://www.facebook.com/events/333722820636596/",
    insta: null
  },
  {
    start: new Date(2019,5,22,20,0),
    end: new Date(2019,5,22,21,0),
    title: "Lehman Wedding",
    information: "",
    fb: null,
    insta: null
  },
  {
    start: new Date(2019,5,28,18,0),
    end: new Date(2019,5,28,21,0),
		title: "AhiMuse Jazz Night",
		information: "Come enjoy steak and sushi at AhiMuse. New tunes every time!",
    fb: "https://www.facebook.com/events/2450367911668077/",
    insta: null
  },
  {
    start: new Date(2019,6,12,18,0),
    end: new Date(2019,6,12,21,0),
		title: "AhiMuse Jazz Night",
		information: "Come enjoy steak and sushi at AhiMuse. New tunes every time!",
    fb: "https://www.facebook.com/events/2450367911668077/",
    insta: null
  },
  {
    start: new Date(2019,6,26,18,0),
    end: new Date(2019,6,26,21,0),
		title: "AhiMuse Jazz Night",
		information: "Come enjoy steak and sushi at AhiMuse. New tunes every time!",
    fb: "https://www.facebook.com/events/2450367911668077/",
    insta: null
  },
  {
    start: new Date(2019,7,5,19,0),
    end: new Date(2019,7,5,20,0),
    title: "Orem Summer Concert Series",
    information: "Free outdoor concert at Center Stage by the Orem Library! We're featuring our original tunes mixed in with some classics.",
    fb: "https://www.facebook.com/events/472091183577099/",
    insta: null
  },
  {
    start: new Date(2019,8,12,17,0),
    end: new Date(2019,8,12,19,0),
    title: "BYU Wilk Terrace Concert",
    information: "We're playing originals and covers for two hours by the CougarEat at BYU for the Rollins Center Kickoff. Come by to say hi and pick up a CD!",
    fb: "https://www.facebook.com/events/2343357275929895/",
    insta: null
  },
  {
    start: new Date(2019,11,7,19,0),
    end: new Date(2019,11,7,20,0),
    title: "Provo Outdoor Christmas Concert",
    information: "A festive outdoor Christmas set featuring original jazz arrangements of classic holiday songs. This is in conjunction with the Provo Christmas Market. Bring the family!",
    fb: "https://www.facebook.com/events/444805256240537/",
    insta: null
  },
  {
    start: new Date(2019,11,20,18,0),
    end: new Date(2019,11,20,20,0),
    title: "Town Hall Christmas Celebration",
    information: "",
    fb: null,
    insta: null
  }
]

export default ShowsList;